import {Pipe, PipeTransform} from '@angular/core';

/**
 * Generated class for the DurationPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'duration',
})
export class DurationPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args) {

    let secs = Number(value);
    let mins: any = (secs / 60).toFixed(0);
    // let s: any = secs % 60;
    /*if (s < 10) {
      s = '0' + s;
    }

    let result;
    if (Number(m) > 0) {
      result = m + ':' + s;
    } else {
      result = '00:' + s;
    }

    let h: any;
    if(Number(m) >= 60){
      h = (m / 60).toFixed(0);
      m = (m % 60).toFixed(0);
      if(m < 10) m = '0' + m;
      result = h + ':' + m + ':' + s;
    }
    return result;*/

    let hours: any = (secs / 3600).toFixed(0);

    let s: any = secs % 60;
    let m: any = mins % 60;
    let h: any = hours;

    if(s < 10) s = '0' + s;
    if(m < 10) m = '0' + m;
    if(h < 10) h = '0' + h;
    return h + ':' + m + ':' + s;
  }
}


@Pipe({
  name: 'duration_to_str',
})
export class Duration2StrPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: number, ...args) {
    return value ? Math.ceil(value / 1000) : null;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/duration/duration.ts